import React from 'react'
import { Popup, Divider, Checkbox } from 'semantic-ui-react'

import { LinkButton } from 'elements/LinkButton'
import CustomFilterValueInputForIsComparison from 'components/CustomFilterValueInputForIsComparison'

/** @typedef {import('shared/components/FilterGroup/reducer').Filter} Filter */
/** @typedef {import('shared/components/FilterGroup/reducer').Comparison} Comparison */
/**
 * @template T
 * @typedef {import('shared/components/FilterGroup/reducer').Rule<T>} Rule
 */

/**
 * @template T
 * @param {object} props
 * @param {Rule<T>} props.rule
 * @param {boolean} props.open
 * @param {React.RefObject} props.context
 * @param {() => void} props.onClose
 * @param {(filters: Filter[]) => void} props.onChange
 * @param {(comparison: Comparison) => void} props.onComparisonChange
 * @param {() => void} props.onExtraChange
 * @param { object[]} props.comparisons
 */
export default function FilterValuesPopover({
  rule,
  open,
  context,
  onClose,
  onChange,
  onComparisonChange,
  comparisons,
  onExtraChange,
}) {
  if (!context || !comparisons) {
    return null
  }

  /**
   *
   * @param {Filter[]} filters
   */
  function handleInputChange(filters) {
    onChange(filters)
  }

  function handleComparisonChange(_, { value }) {
    onComparisonChange(value)

    if (value === 'is_unknown') {
      const filters = [{ value: false }]
      onChange(filters)
    } else if (value === 'has_any_value') {
      const filters = [{ value: true }]
      onChange(filters)
    } else {
      //reset value
      const filters = []
      onChange(filters)
    }
  }

  return (
    <Popup
      on="click"
      open={open}
      onClose={onClose}
      context={context}
      position="bottom left"
      basic
      className="!pb-0"
      style={{ maxWidth: 300, width: 300 }}
    >
      <div className="flex flex-col">
        {comparisons.map((comparison) => {
          const selected = rule.comparison === comparison.value
          const shouldShowInput = selected && comparison.inputComponent
          return (
            <div key={comparison.value} className="pb-1">
              {comparisons.length > 1 && (
                <Checkbox
                  radio
                  label={comparison.label}
                  name="comparison"
                  value={comparison.value}
                  checked={selected}
                  onChange={handleComparisonChange}
                />
              )}
              {shouldShowInput && (
                <div className="py-1">
                  <comparison.inputComponent
                    onChange={handleInputChange}
                    onClose={onClose}
                    defaultFilters={rule.filters}
                    rule={rule}
                    onExtraChange={onExtraChange}
                  />
                </div>
              )}
            </div>
          )
        })}
      </div>

      <Divider className="!-mx-4 !mb-0" />
      <div>
        <div style={{ textAlign: 'center' }} className="py-2">
          <LinkButton onClick={onClose}>Done</LinkButton>
        </div>
      </div>
    </Popup>
  )
}

export const COMPARISONS = [
  { label: 'is', value: 'is', inputComponent: CustomFilterValueInputForIsComparison },
]



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/FilterValuesPopover/index.js